import { Button, ButtonGroup, IButtonProps, Position, Tooltip } from "@blueprintjs/core";
import { IWidgetProps } from "decorator-form";
import React from "react";

import { registerWidget } from "common/form/register";
import IOption from 'common/models/IOption';

export interface IButtonSelectProps<T = string> extends IWidgetProps<T> {
	options: Array<IOption<T>>;
	minimal?: boolean;
	noGroup?: boolean;
	iconOnly?: boolean;
	buttonProps?: IButtonProps;
	fill?: boolean;
}

export default class ButtonSelect<T = string> extends React.PureComponent<IButtonSelectProps<T>> {

	public static withOptions<T>(options: IOption[], extraProps?: Partial<IButtonSelectProps<T>>) {
		return (props: IWidgetProps<string>) => <ButtonSelect {...props} {...extraProps} options={options} />;
	}

	public static registerWithOptions<T>(options: IOption[], extraProps?: Partial<IButtonSelectProps<T>>): string {
		return registerWidget(this.withOptions<T>(options, extraProps), "string");
	}

	public render() {
		const { buttonProps, fill = true, iconOnly, noGroup, value, options, minimal } = this.props;

		const buttons = (options || []).map((o) => {
			const isActive = (o.default && value == null) || value === o.value;
			if (iconOnly) {

				return (
					<Tooltip content={o.label} key={o.value as any} position={Position.TOP}>
						<Button
							minimal={minimal}
							{...buttonProps}
							active={isActive}
							icon={o.icon}
							onClick={() => this.props.onChange(o.value)}
						/>
					</Tooltip>
				);
			}
			return (
				<Button
					minimal={minimal}
					{...buttonProps}
					active={isActive}
					text={o.label}
					onClick={() => this.props.onChange(o.value)}
					key={(o.value) as any}
					icon={o.icon}
				/>
			);
		}

		);

		// if you want this to be a part of a bigger button group
		if (noGroup) {
			return buttons;
		}

		return (
			<ButtonGroup fill={fill}>
				{buttons}
			</ButtonGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/common/ButtonSelect.tsx